import { get } from 'lodash-es';

import { getFoundation } from '../foundation';

import type { ThemeOptions } from '@mui/material';
import type { Foundation } from '@kep/kcds-foundation';
import type { NestedLeafKeyOf } from '../../types/utils';
import type { ThemeMode } from '../foundation';

export type Color = Foundation['color'];

export type ColorPath = NestedLeafKeyOf<Foundation['color'], string, '.'>;
export type ColorKey = NestedLeafKeyOf<Foundation['color'], string, '/'>;

declare module '@mui/material/styles' {
  interface Theme {
    color: Record<ColorKey, string>;
  }
  interface ThemeOptions {
    color: Record<ColorKey, string>;
  }
}

export const createColor = (themeMode: ThemeMode): ThemeOptions['color'] => {
  const foundation = getFoundation(themeMode);

  const color = foundation.color;
  const colorPaths = collectColorObjectKeys(color) as ColorPath[];

  const colorObjectByColorKey = colorPaths.reduce(
    (acc, path) => {
      const value = get(color, path);
      if (value) {
        const key = path.replace(/\./g, '/') as ColorKey;
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<ColorKey, string>,
  );

  return {
    ...colorObjectByColorKey,
  };
};

const collectColorObjectKeys = (
  object: Record<string, any>,
  parentKey = '',
  delimiter = '.',
): string[] => {
  const result: string[] = [];
  for (const key in object) {
    const path = [...parentKey.split(delimiter), key].filter(Boolean).join(delimiter);
    if (typeof get(object, key) === 'string') {
      result.push(path);
    }
    if (typeof object[key] === 'object') {
      result.push(...collectColorObjectKeys(object[key], path, delimiter));
    }
  }
  return result;
};
